export enum CandidatesSourcing {
	LINKEDIN = 'Linkedin',
	WUZZUF = 'Wuzzuf',
	TALENTSARENA = 'Talents Arena',
	SOCIALMEDIA = 'Social Media',
	JOBSTACK = 'JobStack',
	TIEC = 'TIEC',
	NTI = 'NTI',
	GITHUB = 'Github',
	EVENTS = 'Events',
	// CAMPAIGN= {
	// 	FACEBOOK= 'Facebook',
	// 	TWITTER= 'Twitter',
	// 	INSTAGRAM= 'Instagram',
	// 	DEVOPS= 'DevOps'
	// },
	ECPC = 'ECPC',
	REFERER = 'Referral',
	OTHER = 'Other'
}
